
import React from 'react';
import { Link } from 'react-router-dom';
import { KeyRound, ChevronRight, Calendar, Component, MapPinHouse, XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SidebarRentalSubmenuProps {
  collapsed: boolean;
  currentPath: string;
  isRentalActive: boolean;
  rentalSubmenuOpen: boolean;
  onToggleSubmenu: () => void;
}

const rentalSubItems = [
  {
    title: 'Аренды',
    path: '/rentals',
    icon: KeyRound
  },
  {
    title: 'Календарь',
    path: '/rental-calendar',
    icon: Calendar
  },
  {
    title: 'Комплекты',
    path: '/rental-kits',
    icon: Component
  },
  {
    title: 'Кросспункт',
    path: '/cross-location',
    icon: MapPinHouse
  },
  {
    title: 'Отказы',
    path: '/rental-denials',
    icon: XCircle
  }
];

export const SidebarRentalSubmenu: React.FC<SidebarRentalSubmenuProps> = ({
  collapsed,
  currentPath,
  isRentalActive,
  rentalSubmenuOpen,
  onToggleSubmenu
}) => {
  return (
    <div className="relative">
      <div className="flex items-center">
        <Link 
          to="/rentals"
          className={cn(
            'flex-1 flex items-center transition-all duration-200 ease-in-out rounded-md',
            collapsed ? 'justify-center px-2 py-3' : 'px-4 py-3',
            currentPath === '/rentals' ? 'bg-blue-50 text-primary font-medium' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
          )}
          title={collapsed ? 'Аренда' : undefined}
        >
          <KeyRound 
            size={20} 
            className={cn(
              "transition-colors duration-200", 
              currentPath === '/rentals' ? 'text-primary' : 'text-gray-500'
            )} 
          />
          {!collapsed && (
            <span className="ml-3 text-sm transition-opacity duration-200">
              Аренда
            </span>
          )}
        </Link>
        {!collapsed && (
          <button 
            onClick={onToggleSubmenu}
            className="p-2 hover:bg-gray-100 rounded-md transition-colors duration-200"
          >
            <ChevronRight 
              size={16} 
              className={cn(
                "transition-transform duration-300 ease-in-out text-gray-500", 
                rentalSubmenuOpen ? 'rotate-90' : ''
              )} 
            />
          </button>
        )}
      </div>
      
      {/* Submenu */}
      {collapsed ? (
        <div className="space-y-1 mt-1">
          {rentalSubItems.map(subItem => {
            const isSubActive = currentPath === subItem.path;
            return (
              <Link 
                key={subItem.path} 
                to={subItem.path} 
                className={cn(
                  'flex items-center justify-center transition-all duration-200 ease-in-out px-2 py-2 rounded-md',
                  isSubActive ? 'bg-blue-50 text-primary font-medium' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                )}
                title={subItem.title}
              >
                <subItem.icon 
                  size={16}
                  className={cn(
                    "transition-colors duration-200", 
                    isSubActive ? 'text-primary' : 'text-gray-500'
                  )}
                />
              </Link>
            );
          })}
        </div>
      ) : (
        rentalSubmenuOpen && (
          <div className="pl-6 space-y-1 mt-1">
            {rentalSubItems.map(subItem => {
              const isSubActive = currentPath === subItem.path;
              return (
                <Link 
                  key={subItem.path} 
                  to={subItem.path} 
                  className={cn(
                    'flex items-center transition-all duration-200 ease-in-out px-4 py-2 rounded-md text-sm',
                    isSubActive ? 'bg-blue-50 text-primary font-medium' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  )}
                >
                  <subItem.icon 
                    size={16}
                    className={cn(
                      "mr-2 transition-colors duration-200", 
                      isSubActive ? 'text-primary' : 'text-gray-500'
                    )}
                  />
                  <span>{subItem.title}</span>
                </Link>
              );
            })}
          </div>
        )
      )}
    </div>
  );
};
